import axiosInstance from '../../../config/axiosConfig';
import { urlTiposVulnerabilidad } from '../../../config/apiURL';
import { extractArray, extractDataObject } from '../../utils/responseHelpers';

// Obtener todos los tipos de vulnerabilidad
export async function getTiposVulnerabilidad() {
  try {
    const response = await axiosInstance.get(urlTiposVulnerabilidad);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching tipos de vulnerabilidad:', error);
    throw error;
  }
}

// Obtener un tipo de vulnerabilidad por ID
export async function getTipoVulnerabilidadById(id) {
  try {
    const response = await axiosInstance.get(`${urlTiposVulnerabilidad}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching tipo vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export async function createTiposVulnerabilidades(formulario) {
  try {
    const response = await axiosInstance.post(urlTiposVulnerabilidad, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating tipo vulnerabilidad:', error);
    throw error;
  }
}

export async function updateTiposVulnerabilidades(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlTiposVulnerabilidad}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating tipo vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export async function deleteTiposVulnerabilidades(id) {
  try {
    const response = await axiosInstance.delete(`${urlTiposVulnerabilidad}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting tipo vulnerabilidad ${id}:`, error);
    throw error;
  }
}